import React from 'react';
import { NumericFormat } from 'react-number-format';
import { CurrencyInputProps } from './types';
import { MaterialInputCustom } from './CurrencyInput.styles';

export { MaterialInputCustom, Symbol } from './CurrencyInput.styles';

const CurrencyInput = (props: CurrencyInputProps) => {
  // @ts-expect-error CurrencyInputProps inherits MUI TextField's `value?: unknown`, wider than react-number-format's `value?: string | number | null`
  return <NumericFormat customInput={MaterialInputCustom} thousandSeparator="," {...props} />;
};

export default CurrencyInput;
